import React from 'react';
/**
 *
 * @param {import('./types').SelectOption} option
 * @param {number} index
 */

var renderOption = function (option, index) {
  var disabled = option.disabled,
      id = option.id,
      label = option.label,
      value = option.value;
  return /*#__PURE__*/React.createElement("option", {
    disabled: disabled,
    key: id || value || index,
    value: value
  }, label);
};
/**
 * @param {object} options
 * @param {import('react').ReactNode} [options.children]
 * @param {import('./types').Props['options']} options.options
 * @return {JSX.Element}
 */


export var renderContent = function (_ref) {
  var children = _ref.children,
      options = _ref.options;
  if (children) return children;
  return options.map(function (option, index) {
    if ('options' in option) {
      var groupKey = option.id || option.label || index;
      return /*#__PURE__*/React.createElement("optgroup", {
        key: groupKey,
        label: option.label
      }, option.options.map(renderOption));
    }

    return renderOption(option, index);
  });
};